import axios from './axios';

export const createUser = async (data) => {
  delete data.terms;
  const res = await axios({
    method: 'POST',
    url: '/api/user/create',
    data,
  });

  return res.data;
};

export const loginUser = async (data) => {
  const res = await axios({
    method: 'POST',
    url: '/api/user/login',
    data,
  });

  return res.data;
};

export const getUser = async () => {
  const res = await axios({
    method: 'GET',
    url: '/api/user',
  });

  return res.data;
};

export const updateUser = async (data) => {
  const res = await axios({
    method: 'PUT',
    url: '/api/user',
    data,
  });

  return res.data;
};

export const updatePassword = async (data) => {
  delete data.confirmPassword;
  const res = await axios({
    method: 'PUT',
    url: '/api/user/password',
    data,
  });

  return res.data;
};

export const getAllUsers = async (userType) => {
  if (userType !== 'admin') return;

  const res = await axios({
    method: 'GET',
    url: '/api/user/users',
  });

  return res.data;
};

export const updateUserById = async ({ userType, data, userId }) => {
  if (userType !== 'admin') return;
  const res = await axios({
    method: 'PUT',
    url: `/api/user/${userId}`,
    data,
  });

  return res.data;
};

export const verifyAccount = async (email, otp) => {
  const res = await axios({
    method: 'POST',
    url: `/api/auth/verify-email`,
    data: { email, otp },
  });

  return res.data;
};

export const resendOTP = async (email, activity) => {
  const res = await axios({
    method: 'POST',
    url: `/api/auth/resendOTP`,
    data: { email, activity },
  });

  return res.data;
};

export const changePassword = async (password, token) => {
  const res = await axios({
    method: 'PUT',
    url: `/api/auth/password`,
    data: { password, token },
  });

  return res.data;
};

export const verifyPasswordOTP = async (email, otp) => {
  const res = await axios({
    method: 'POST',
    url: `/api/auth/password/verify`,
    data: { email, otp },
  });

  return res.data;
};
